import { isoZ, z } from 'my-zod'

/**
 * This stores values which are necessary for "dynamic pricing". These
 * are values which are true at the time the customer booking this reservation,
 * but are not reproducible from the db.
 *
 * The signature on this object ensures the values in the context were provided
 * by the backend and not tampered with on the frontend.
 */
export const reservationVehicleCreateContext = z.object({
  /** cannot alter the context in any way*/
  signature: z.string().min(1),
  /** cannot take context created at a radically different time and use it now */
  quotedDate: isoZ.instant(),
  /** needed to know  */
  quotedDateLocal: isoZ.date(),
  quotedTimeLocal: isoZ.time(),
  numberOfUnitsAvailable: z.number().int().nonnegative()
})
export type reservationVehicleCreateContext = z.infer<typeof reservationVehicleCreateContext>

export const reservationVehicleCreateContextInput = z.object({
  /** cannot take the context for one date/time and use it on another date/time */
  beginDate: isoZ.date(),
  endDate: isoZ.date(),
  ridingStartTime: isoZ.time(),
  ridingEndTime: isoZ.time(),
  /** cannot take the context for one product and use it on another product */
  productId: z.string()
})
export type reservationVehicleCreateContextInput = z.infer<typeof reservationVehicleCreateContextInput>
